import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import Video from "../components/video"
import Carousel from "../components/carousel"

import "./instagram.css"

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="Marina Matovic | Fashion Designer" />
    <div className="items">
      {data.allInstagramContent.edges.map((image, index) => {
        const sources = [image.node.localImage.childImageSharp.fluid]
        const { videos, carousel_media } = image.node
        return (
          <div className="item" key={index}>
            <a href={image.node.link} target="_blank">
              {!videos ? (
                carousel_media ? (
                  <Carousel carousel_media={carousel_media}></Carousel>
                ) : (
                  <Img fluid={sources} />
                )
              ) : (
                <Video videoSrcURL={videos.standard_resolution.url} />
              )}
            </a>
            {image.node.caption && (
              <div className="caption">{image.node.caption.text}</div>
            )}
          </div>
        )
      })}
    </div>
  </Layout>
)

export const query = graphql`
  query {
    allInstagramContent {
      edges {
        node {
          localImage {
            childImageSharp {
              fluid(maxHeight: 500, maxWidth: 500, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          caption {
            text
          }
          link
          images {
            standard_resolution {
              url
            }
          }
          carousel_media {
            images {
              standard_resolution {
                url
              }
            }
          }
          videos {
            standard_resolution {
              url
            }
          }
        }
      }
    }
  }
`

export default IndexPage
